export default __webpack_public_path__ + "img/resident.28e44cb7.png";